import { render, staticRenderFns } from "./VerticalNavMenuSectionTitle.vue?vue&type=template&id=4f3d0923&scoped=true"
import script from "./VerticalNavMenuSectionTitle.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuSectionTitle.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuSectionTitle.vue?vue&type=style&index=0&id=4f3d0923&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d0923",
  null
  
)

export default component.exports